// extracted by mini-css-extract-plugin
export var aircallIframe = "_lo-3";
export var fabContainer = "_lo-5";
export var fabRinging = "_lo-6";
export var loadingOverlay = "_lo-4";
export var pulse = "_lo-7";
export var widgetContent = "_lo-2";
export var widgetPanel = "_lo-0";
export var widgetPanelExpanded = "_lo-1";